import { Controller } from "@hotwired/stimulus"
import mrujs from "mrujs"

// Kicks off a PDF export and renders the turbo-stream response (open the
// download modal + start polling). mrujs.fetch is kept only for its CSRF
// handling.
export default class extends Controller {
  static values = {
    url: String,
    bodyAsHtml: { type: Boolean, default: true }
  }

  generate(e) {
    e.preventDefault()
    let body = null
    let method = "GET"

    if (this.bodyAsHtmlValue) {
      const html = document.querySelector("html").outerHTML
      body = JSON.stringify({ html })
      method = "POST"
    }

    mrujs
      .fetch(this.urlValue, {
        method,
        headers: { "Accept": "text/vnd.turbo-stream.html" },
        body
      })
      .then(resp => resp.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }
}
